import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    interval: { type: Number, default: 4000 },
    url: String
  }

  connect() {
    this.frame = this.element.closest("turbo-frame")
    this.beforeFetch = this.beforeFetch.bind(this)
    this.afterFetch = this.afterFetch.bind(this)
    this.fetchFailed = this.fetchFailed.bind(this)

    if (this.frame) {
      this.frame.addEventListener("turbo:before-fetch-request", this.beforeFetch)
      this.frame.addEventListener("turbo:frame-load", this.afterFetch)
      this.frame.addEventListener("turbo:fetch-request-error", this.fetchFailed)
    }

    this.schedule()
  }

  disconnect() {
    this.stop()

    if (this.frame) {
      this.frame.removeEventListener("turbo:before-fetch-request", this.beforeFetch)
      this.frame.removeEventListener("turbo:frame-load", this.afterFetch)
      this.frame.removeEventListener("turbo:fetch-request-error", this.fetchFailed)
    }
  }

  schedule() {
    this.stop()
    this.timer = setTimeout(() => this.reload(), this.intervalValue)
  }

  stop() {
    if (!this.timer) return

    clearTimeout(this.timer)
    this.timer = null
  }

  reload() {
    this.timer = null

    if (!this.frame || this.frame.hasAttribute("busy")) {
      this.schedule()
      return
    }

    const url = this.hasUrlValue ? this.urlValue : window.location.href
    this.pollUrl = new URL(url, window.location.href).href
    this.pollPending = true

    // Setting src triggers a fetch; reload() is needed when src is unchanged.
    if (this.frame.src === this.pollUrl) {
      this.frame.reload()
    } else {
      this.frame.src = url
    }
  }

  beforeFetch(event) {
    const requestUrl = event.detail.url?.href || event.detail.url?.toString()
    if (this.pollPending && requestUrl === this.pollUrl) {
      this.pollPending = false
      this.pollInFlight = true
      return
    }

    this.pollPending = false
    this.pollInFlight = false
    this.stop()
  }

  afterFetch() {
    this.pollPending = false
    this.pollInFlight = false
    this.schedule()
  }

  fetchFailed() {
    const shouldResume = this.pollInFlight
    this.pollPending = false
    this.pollInFlight = false
    if (shouldResume) this.schedule()
  }
}
